/** Served from public/Logo.png (committed for CI builds) */
export const BRAND_LOGO_SRC = `${process.env.PUBLIC_URL}/Logo.png`;
